import React, { Component, ErrorInfo, ReactNode } from "react"
import { t } from "@lingui/macro"
import ErrorBox from "./ErrorBox/ErrorBoxServer"

type ErrorBoundaryProps = React.PropsWithChildren<{
    sendToRollbar?: boolean
}>

class ErrorBoundaryRoot extends Component<ErrorBoundaryProps> {
    static defaultProps: ErrorBoundaryProps = {
        sendToRollbar: true,
    }

    state = {
        error: null,
    }

    static getDerivedStateFromError(error: Error) {
        return { error }
    }

    componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
        if (window?.rollbar && this.props.sendToRollbar) window.rollbar.error(error)
    }

    render(): ReactNode {
        // console.log("Error Boundary Render", this.state)

        if (this.state.error) {
            return (
                <ErrorBox
                    title={t`Client error`}
                    button={{
                        label: t`Go to www.silversea.com`,
                        onClick: () => (window.location.href = "https://www.silversea.com"),
                    }}
                    message={t`We apologize, please try your configuration again.`}
                />
            )
        }
        return this.props.children
    }
}

export default ErrorBoundaryRoot
